import {type DeliveryAddressesResponse, doGET, shopRestBackendBaseUrl} from 'dummen-shared';

const CUSTOMER_REST_BACKEND_BASE = `${shopRestBackendBaseUrl}/secured/app/customers`;
const DELIVERY_ADDRESS_ENDPOINT = `${CUSTOMER_REST_BACKEND_BASE}/delivery-addresses`;

export const fetchDeliveryAddresses = async (): Promise<DeliveryAddressesResponse> => {
	const response = await doGET(DELIVERY_ADDRESS_ENDPOINT);

	return await response.json();
};
